import React from "react";
import { Link } from "react-router-dom";

import { buildAuditUrl } from "./auditEntityConfig";

export default function AuditActionLink({
  slug,
  id,
  name,
  className = "",
}) {
  return (
    <Link
      to={buildAuditUrl(slug, id, name)}
      target="_blank"
      rel="noopener noreferrer"
      className={`ml-2 inline-flex items-center rounded-md bg-sky-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-sky-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-sky-600 ${className}`.trim()}
    >
      Audit
    </Link>
  );
}
